// extracted by mini-css-extract-plugin
export const mapLink = "bk_T";
export const deleteBtn = "bk_V";
export const noShopTxt = "bk_cG";
export const table = "bk_cH";